module.exports = __webpack_public_path__ + "images/e09815eba4e85232c76d4a903c10b651.png";